import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { mergeMap, of } from "rxjs";
import * as errorActions from "./error.actions";
import { map } from 'rxjs/operators';
import { BugsnagService } from "../../services/bugsnag.service";

@Injectable()
export class ErrorEffects {
    constructor(
        private actions$: Actions,
        private toastController: ToastController,
        private bugsnagService: BugsnagService
    ) {}

    showErrorMessage$ = createEffect(() => this.actions$.pipe(
        ofType(errorActions.handleError),
        mergeMap(({ error, showToast, exception }) => 
            {
                this.bugsnagService.notify(exception);
                if (showToast) {
                    return this.toastController.create({
                    message: error,
                    duration: 3000
                }).then(toast => {
                        toast.present();
                        return of(errorActions.errorHandled());
                    });
                }
                return of(errorActions.errorHandled());
            }
        ),
        map(() => errorActions.errorHandled())
    ));
}
